/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { styled } from '@mui/material';
import { TestIds } from '../../../testIds';
import Typography from '../../../components/Typography';

const ListContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

interface ProductListProps<T> {
  items: T[];
  renderListItem: (item: T) => React.ReactElement;
}

const ProductList = <T,>({ items, renderListItem }: ProductListProps<T>) => {
  const noFilterResult = (
    <Typography variant='body1' data-testid={TestIds.feat.product.list.noProductsByFilters} mb={2}>
      There are no products matching your search. Try adjusting your filters to broaden your search.
    </Typography>
  );

  return (
    <ListContainer>
      {items.length === 0 && noFilterResult}
      {items.map((item) => renderListItem(item))}
    </ListContainer>
  );
};

export default ProductList;
